/**
 * « Paramètres d'inscription » (`configuration`): the head and its link, then every section card top
 * to bottom, then Save. Each section step opens its card (`section`, William 28 Oct 2026: « ouvrir les
 * sections lors de la description », then « le guide doit être complet ») so the organizer sees the
 * form the bubble talks about; the accordion goes back to its previous state when the tour ends.
 * Novice copy.
 */
export const REGISTRATION_SETTINGS_TOUR = {
    id: 'registration-settings',
    version: 1,
    paths: ['configuration'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'Your registration settings',
            description:
                'Everything athletes see when they register: dates, prices, categories. The line under the title tells you if registration is open; « Preview » opens the form as they see it.',
        },
        {
            key: 'link',
            target: '[data-tour="page-copy-link"]',
            placement: 'bottom',
            title: 'The registration link',
            description:
                'Copies the address of your registration form, to share it on your website, your social networks or by e-mail.',
        },
        {
            key: 'dates',
            target: '[data-tour="sec-dates"]',
            section: 'dates',
            placement: 'bottom',
            title: 'When registration opens',
            description:
                'Choose the opening and closing dates, or open right now. Cards marked « Essential » must be filled before registration opens; « Next » at the bottom takes you to the following card.',
        },
        {
            key: 'access',
            target: '[data-tour="sec-access"]',
            section: 'access',
            placement: 'bottom',
            title: 'Who can reach the form',
            description:
                'Let athletes edit their registration until a date, protect the form with a password for a while, and copy the public link.',
        },
        {
            key: 'payments',
            target: '[data-tour="sec-payments"]',
            section: 'payments',
            placement: 'bottom',
            title: 'How athletes pay',
            description: 'Connect your payment account, set the currency and the default price.',
        },
        {
            key: 'divisions',
            target: '[data-tour="sec-divisions"]',
            section: 'divisions',
            placement: 'bottom',
            title: 'Categories and spots',
            description:
                'Create the categories athletes register in, with their price and their number of spots. « New division » at the top of the card adds one; drag the cards to reorder them.',
        },
        {
            key: 'promos',
            target: '[data-tour="sec-promos"]',
            section: 'promos',
            placement: 'bottom',
            title: 'Promo codes',
            description:
                'A code gives a discount on the whole event; a category can carry its own. A code cannot be changed once created: delete it and create a new one.',
        },
        {
            key: 'products',
            target: '[data-tour="sec-products"]',
            section: 'products',
            placement: 'bottom',
            title: 'Extra products',
            description:
                'T-shirts, meals, goodies: items athletes can add to their registration, included or paid, with a stock and options if needed.',
        },
        {
            key: 'fields',
            target: '[data-tour="sec-fields"]',
            section: 'fields',
            placement: 'bottom',
            title: 'Questions for athletes',
            description:
                'Extra questions asked on the form: text, choice, file… A question can be shown only when another answer calls for it.',
        },
        {
            key: 'notes',
            target: '[data-tour="sec-notes"]',
            section: 'notes',
            placement: 'bottom',
            title: 'Your notes to athletes',
            description: 'Short messages shown on the registration form, at the place you choose.',
        },
        {
            key: 'rules',
            target: '[data-tour="sec-rules"]',
            section: 'rules',
            placement: 'bottom',
            title: 'Rules and terms',
            description:
                'The text athletes accept when they register: rules, terms and conditions. Write it in the editor, it is shown on the form.',
        },
        {
            key: 'save',
            target: '[data-tour="page-save"]',
            placement: 'bottom',
            placementNarrow: 'top',
            title: 'Save your changes',
            description:
                'Nothing is applied until you save. While an essential section is missing, the button saves a draft. « Discard » cancels the unsaved changes.',
        },
    ],
}

export default REGISTRATION_SETTINGS_TOUR
